export const CACHE_KEYS = {
  USERS: "tm_users_cache",
  PROVIDERS: "tm_providers_cache",
  NOTIFICATIONS: "tm_notifications_cache",
  USER_GROUPS: "tm_user_groups_cache"
};

export const CACHE_TTL = {
  USERS: 5 * 60 * 1000,
  PROVIDERS: 30 * 60 * 1000,
  NOTIFICATIONS: 2 * 60 * 1000,
  USER_GROUPS: 5 * 60 * 1000
};

export const getCacheEntry = (key, ttl) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;

    const { data, timestamp } = JSON.parse(raw);
    if (Date.now() - timestamp > ttl) {
      localStorage.removeItem(key);
      return null;
    }
    return { data, timestamp };
  } catch {
    localStorage.removeItem(key);
    return null;
  }
};

export const getCache = (key, ttl) => {
  return getCacheEntry(key, ttl)?.data ?? null;
};

export const setCache = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify({ data, timestamp: Date.now() }));
  } catch (error) {
    if (error?.name === "QuotaExceededError") {
      clearAllCaches();
    }
  }
};

export const clearCache = (key) => {
  localStorage.removeItem(key);
};

export const clearAllCaches = () => {
  Object.values(CACHE_KEYS).forEach((key) => localStorage.removeItem(key));
};
